import { IconArrowUpRight } from '@tabler/icons-react'
import React from 'react'
import { Link } from 'react-router-dom'

const Section3 = ({datas}) => {
  return (
    <>
        <div className='row s3-features s3-fin-reco f-width m-auto'>
            <div className='col-lg-6 col-sm-12'>
                <p className='fs-md'>{datas.heading}</p>
                {datas.subHead1 ? <p className='s2-t-m'><font className="fw-bold">{datas.subHead1}:</font></p> : <></>}
                <p className='s2-t-m'>{datas.p1}</p>
                {datas.subHead2 ? <p className='s2-t-m'><font className="fw-bold">{datas.subHead2}:</font></p> : <></>}
                <p className='s2-t-m'>{datas.p2}</p>
            </div>
            <div className='col-lg-6 col-sm-12 text-center align-content-center'>
                <Link to={datas.btnLink}>
                    <div className='btn btn-outline-dark rounded-pill py-3 px-5'>{datas.btnText} <IconArrowUpRight className='ms-1' /> </div>
                </Link>
            </div>
        </div>
    </>
  )
}

export default Section3